export default {
  path: 'title-lists',
  name: 'product',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "product-show-title-lists" */ './TitleListsTab')
}
